export default "__VITE_ASSET__0aad6980__"